<h1 class="text-center">
  Vítejte v EchopixCMS! Začněte výběrem položky z menu vlevo.
</h1>
